import React, { useState } from "react";
import { Row, Col } from "reactstrap";
import { makeStyles } from "@material-ui/core/styles";
import { GridList, GridListTile, GridListTileBar } from "@material-ui/core";
import { FileStorageSearchbar } from "./FileStorageSearchbar";
import PictureDisplay from "../../PictureDisplay";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-around",
    overflow: "hidden",
    backgroundColor: theme.palette.background.paper,
  },
  gridList: {
    width: "100%",
    height: "100%",
    maxHeight: "calc(100vh - 130px)",
    overflowY: "auto",
    padding: 10,
    marginTop: 10,
  },
  icon: {
    color: "rgba(255, 255, 255, 0.54)",
  },
}));

export function FileStorageGrid(props) {
  const classes = useStyles();
  const [filter, setFilter] = useState("");
  const { files = [], selectedFile, onSelect, type, filterType } = props;
  return (
    <div
      style={{
        padding: 10,
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <FileStorageSearchbar
        filterFiles={setFilter}
        result={files ? files.length : 0}
      />
      <GridList
        cellHeight={150}
        style={{
          width: "100%",
          maxHeight: "100%",
          overflowY: "auto",
          padding: 10,
          marginTop: 10,
        }}
        className="layout-list"
        cols={4}
      >
        {files
          .filter((f, i) => {
            return (
              (filterType.includes(
                f.type.substring(f.type.lastIndexOf("/") + 1).toUpperCase()
              ) ||
                filterType.includes(
                  f.type.substring(f.type.lastIndexOf("/") + 1).toLowerCase()
                )) &&
              f.name.toLowerCase().includes(filter.toLowerCase()) &&
              f
            );
          })
          .map((f, i) => {
            return (
              <GridListTile
                onClick={() => onSelect(f)}
                key={i}
                style={{ position: "relative" }}
              >
                <div
                  className={
                    "storage-content-card" +
                    (selectedFile && selectedFile.name == f.name
                      ? " storage-selected-container"
                      : "")
                  }
                >
                  {f.type.includes("image") && (
                    <PictureDisplay
                      src={f.url}
                      srcset={f.srcset}
                      viewWidth={"25vw"} //TODO Replace hardcoded value with calculated view width
                      className={"preview-image"}
                      alt={"_blank"}
                    />
                  )}
                  {f.type.includes("font") ? <FontPreview font={f} /> : null}
                  {f.type.includes("pdf") ? (
                    <div style={{ width: "100%", textAlign: "center" }}>
                      <i
                        className="fa fa-file-pdf-o"
                        style={{ fontSize: "7em" }}
                      />
                    </div>
                  ) : null}
                  <GridListTileBar
                    title={f.name.substring(f.name.lastIndexOf("/") + 1, 18)}
                    subtitle={
                      !f.type.includes("pdf") ? (
                        <span className="secondary-text">
                          {Math.round(f.size * 0.001 * 10) / 10}
                          {" kB   "}
                        </span>
                      ) : (
                        f.type
                      )
                    }
                  />
                </div>
                {selectedFile && selectedFile.name === f.name && (
                  <div className={"storage-selected-overlay"}>
                    <span
                      href="#"
                      className={"storage-selected-icon"}
                      title="image"
                    >
                      <i className="fa fa-check-circle selected-icon"></i>
                    </span>
                  </div>
                )}
              </GridListTile>
            );
          })}
      </GridList>
    </div>
  );
}

{
  /* <GridListTileBar
title={tile.title}
subtitle={<span>by: {tile.author}</span>}
actionIcon={
  <IconButton aria-label={`info about ${tile.title}`} className={classes.icon}>
    <InfoIcon />
  </IconButton>
}
/> */
}

const FontPreview = (file) => {
  const { url, name } = file.font;
  return (
    <div style={{ height: "100%", padding: 10, background: "#fff" }}>
      <p
        style={{
          fontFamily: convertFont(name),
          fontSize: "16px",
        }}
      >
        {convertFont(name)}
      </p>
      <p
        style={{
          fontFamily: convertFont(name),
          fontSize: "20px",
        }}
      >
        {convertFont(name)}
      </p>
      <p
        style={{
          fontFamily: convertFont(name),
          fontSize: "24px",
        }}
      >
        {convertFont(name)}
      </p>
      <style>{`
                            @font-face {
                                font-family: ${convertFont(name)};
                                src: url('${url}');
                            }
                            `}</style>
    </div>
  );
};

const convertFont = (f) => {
  return f
    .substring(f.lastIndexOf("/") + 1, f.lastIndexOf(".") + 1)
    .toString()
    .replace(")", "")
    .replace("(", "")
    .replace(".", "")
    .replace("1", "")
    .replace("", "");
};
